import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/buttons/button";
import { AuthHeader } from "../../../../components/typography/authHeader";
import { useAppSelector } from "../../../../redux/hooks";

export const DownloadBackUpCodes = () => {
  const navigate = useNavigate();
  const { backUpCodes } = useAppSelector((state) => state.auth);

  return (
    <form className="flex w-full flex-col">
      <div className="flex w-full items-center justify-center">
        <img
          src="/assets/check-mark-glass.svg"
          className="flex h-[120px] w-[150px]"
          alt="logo"
        />
      </div>
      <section className="flex w-full flex-col gap-2.5">
        <AuthHeader
          header="2FA has been enabled"
          text={
            <span>
              Download your backup codes and keep there safe. If you lose access
              to your authentication device, you can use any of these codes to
              login to your account.
            </span>
          }
        />

        <main className="my-5 w-full rounded-lg border border-gray-100 py-[32px]">
          <div className="mx-auto grid w-[90%] grid-cols-2 justify-items-center gap-5 md:w-[324px]">
            {backUpCodes?.map((code, index) => (
              <p className="text-sm text-primary" key={index}>
                {code}
              </p>
            ))}
          </div>
        </main>
        <div className="flex w-full flex-col items-center justify-center gap-2.5">
          <Button
            text={"Download backup codes"}
            type="button"
            onClick={() => {
              if (!backUpCodes || backUpCodes.length === 0) return;

              const fileContent = backUpCodes.join("\n");
              const blob = new Blob([fileContent], { type: "text/plain" });
              const url = URL.createObjectURL(blob);

              const a = document.createElement("a");
              a.href = url;
              a.download = "2fa-backup-codes.txt";

              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
            }}
            variation="plain-grey"
            className="w-full"
          />
          <Button
            text={"Continue"}
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              navigate("/overview");
            }}
            className="w-full"
            variation={"primary"}
          />
        </div>
      </section>
    </form>
  );
};
